export function HBar({
  label,
  value,
  max,
  currency,
}: {
  label: string;
  value: number;
  max: number;
  currency?: string;
}) {
  const pct = max > 0 ? (value / max) * 100 : 0;
  return (
    <div style={{ marginBottom: 8 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: 12,
          color: "#555",
          marginBottom: 3,
        }}
      >
        <span>{label}</span>
        <span style={{ fontWeight: 600 }}>
          {currency ?? ""}
          {value.toLocaleString(undefined, { maximumFractionDigits: 0 })}
        </span>
      </div>
      <div
        style={{
          height: 8,
          background: "#e8eaf0",
          borderRadius: 4,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${pct}%`,
            background: "#4f46e5",
            borderRadius: 4,
          }}
        />
      </div>
    </div>
  );
}
